import { invokeApi } from ".";
import * as endPoints from "../constants/ApiEndpoints";
import { getFromEncLocalStorage } from "../helpers/Utils/Utils";

export const queByMe = async (reqBody) => {
  const token = await getFromEncLocalStorage("token");
  const data = await invokeApi(endPoints.getQueByMeApi, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: token,
    },
    payload: reqBody,
  });

  return data;
};

const QueByMeService = { queByMe };
export default QueByMeService;
